import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useWishlist } from '../context/WishlistContext';
import { getProdutos } from '../services/api';
import ProductCard from '../components/ProductCard';
import './ListaDesejos.css';

const ListaDesejos = () => {
  const { productIds } = useWishlist();
  const [produtos, setProdutos] = useState([]);
  const [loading, setLoading] = useState(true);

  const productIdsStr = productIds.join(',');
  useEffect(() => {
    if (productIds.length === 0) {
      setProdutos([]);
      setLoading(false);
      return;
    }
    getProdutos()
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : (res.data?.data || []);
        const list = (data || []).filter((p) => productIds.includes(p.id));
        setProdutos(list);
      })
      .catch(() => setProdutos([]))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productIdsStr]);

  if (productIds.length === 0 && !loading) {
    return (
      <div className="lista-desejos-page">
        <div className="container">
          <h1 className="page-title">Lista de Desejos</h1>
          <div className="lista-desejos-vazia">
            <p>Você ainda não adicionou nenhum produto à lista de desejos.</p>
            <Link to="/produtos" className="btn-secondary">Ver produtos</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="lista-desejos-page">
      <div className="container">
        <h1 className="page-title">Lista de Desejos ({produtos.length})</h1>
        {loading ? (
          <p className="loading">Carregando...</p>
        ) : (
          <div className="products-grid-mercadolivre">
            {produtos.map((produto) => (
              <ProductCard key={produto.id} produto={produto} showWishlistHeart />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ListaDesejos;
